import { Box, Grid } from 'pounceV2';
import React from 'react';
import EditorPanelV3 from 'Pages/Build/Detections/CorrelationRules/EditorPanelV3';
import { useTheme } from '@mui/material';
import CorrelationRuleFlowChartBuilderV3 from './CorrelationRuleFlowChartBuilderV3';

interface CorrelationRuleEditorProps {
  readOnly?: boolean;
}

const CorrelationRuleEditorV3 = ({ readOnly = false }: CorrelationRuleEditorProps) => {
  const {
    palette: { tokens },
  } = useTheme();
  return (
    <Box height="100%" overflowY="hidden">
      <Grid
        columnGap={3}
        templateColumns="1fr 1fr"
        height="100%"
        backgroundColor={tokens.background.neutral.mid[3]}
      >
        <Box
          sx={{
            height: '100%',
            overflowY: 'hidden',
            backgroundColor: tokens.background.neutral.inverse.raisedToBrand[4],
          }}
        >
          <CorrelationRuleFlowChartBuilderV3 />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflowY: 'hidden',
            backgroundColor: tokens.background.neutral.mid[3],
          }}
        >
          <EditorPanelV3 readOnly={readOnly} />
        </Box>
      </Grid>
    </Box>
  );
};

export default CorrelationRuleEditorV3;
